import { render, staticRenderFns } from "./PaywallCoursesList.vue?vue&type=template&id=2aec3655&scoped=true&"
import script from "./PaywallCoursesList.vue?vue&type=script&lang=ts&"
export * from "./PaywallCoursesList.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallCoursesList.vue?vue&type=style&index=0&id=2aec3655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec3655",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2aec3655', component.options)
    } else {
      api.reload('2aec3655', component.options)
    }
    module.hot.accept("./PaywallCoursesList.vue?vue&type=template&id=2aec3655&scoped=true&", function () {
      api.rerender('2aec3655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/components/PaywallCoursesList.vue"
export default component.exports